/* eslint-disable max-len */
import React from "react";

import { IconPack, SecondaryNavContent } from "../../models/app-data-model";
import Divider from "../divider/divider";
import MenuLabel from "../menu-label/menu-label";
import ShLink from "../sh-link/sh-link";

export type NavMenuContentProps = {
  content: SecondaryNavContent;
  iconPack?: IconPack[];
};

const NavMenuContent: React.FC<NavMenuContentProps> = ({ content, iconPack }: NavMenuContentProps) => {
  return (
    <>
      {content.image && <img className="image" src={content.image?.file.url} alt={content.image?.alt_text} />}
      {content.paragraph && <p className="paragraph">{content.paragraph.text}</p>}
      {content.divider && <Divider />}
      {content.vertical_space && <div className="vertical-blank-space"></div>}
      {content.menu_label && <MenuLabel label={content.menu_label.text} />}
      {content.primary_nav_item && <h1 className="primary-item-title">{content.primary_nav_item.title}</h1>}
      {content.secondary_nav_item && (
        <div data-testid="secondary-div-wrapper" className="secondary-div-wrapper">
          <ShLink
            regionalLinkAsButton={true}
            className="secondary-item-link"
            dataTestId="secondary-item-link-test"
            reference={content.secondary_nav_item.reference}
            title={content.secondary_nav_item.title}
            iconPack={iconPack}
          />
        </div>
      )}
    </>
  );
};

export default NavMenuContent;
